import { WidgetWrapperComponent } from './widget-wrapper.component';

/** TODO this is a problematic solution to globally store the currently/last dragged widget
 *  and we should find a better solution. DZ 01/21.
 */
export class DraggedWidgetHolder {
  public static draggedWidget: WidgetWrapperComponent;
}
